var $119d0bb165974b5e$exports = {};
$119d0bb165974b5e$exports = {
    "valid": `\u{5EA}\u{5B8}\u{5E7}\u{5B5}\u{5E3}`
};


export {$119d0bb165974b5e$exports as default};
//# sourceMappingURL=he-IL.mjs.map
